import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import { TermsAndConditionsResult } from '@fantaz/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsService {
  constructor(private http: HttpClient) {}

  /**
   * Fetch terms and conditions
   */
  fetchTermsInfo(): Observable<TermsAndConditionsResult> {
    return this.http.get<TermsAndConditionsResult>(
      `${environment.baseURL}/terms/terms.json`,
    );
  }

  /**
   * Update data of user when accepted terms and conditions
   */
  saveAcceptedTerms(): Observable<void> {
    return this.http.put<void>(`${environment.baseURL}/policies/accept`, {});
  }
}
